var map = {
	"./Rectangle 9273.svg": "2cd2",
	"./Rectangle 9292.svg": "c210",
	"./Vector.svg": "e455",
	"./actual.svg": "1815",
	"./add.svg": "76a4",
	"./arms.svg": "de8a",
	"./arrow-back.svg": "b8a8",
	"./arrow-download.svg": "5d82",
	"./arrow-exit.svg": "5402",
	"./arrow-left.svg": "ac3b",
	"./arrow-next.svg": "17f9",
	"./arrow-prev.svg": "4b82",
	"./arrow-statistic.svg": "b19b",
	"./arrow-up-s.svg": "ec2f",
	"./arrow.svg": "21e2",
	"./arrow_back.svg": "d73b",
	"./arrow_black_left.svg": "f068",
	"./arrow_btn.svg": "3a03",
	"./arrow_grey_right.svg": "d950",
	"./arrow_nav_left.svg": "4134",
	"./arrow_nav_right.svg": "6dce",
	"./arrow_up.svg": "1ad6",
	"./arrow_upload.svg": "e8e3",
	"./bottom-arr.svg": "d633",
	"./btn_star.svg": "d59e",
	"./button_spinner.svg": "b610",
	"./certificate.svg": "3f13",
	"./change-photo.svg": "c280",
	"./check.svg": "7bae",
	"./close-elipse.svg": "0025",
	"./close.svg": "8b1b",
	"./create-report.svg": "ceed",
	"./cross-sm.svg": "3b5f",
	"./cross.svg": "2ad7",
	"./dart-logo.svg": "3bf0",
	"./dots.svg": "93d2",
	"./download_file.svg": "c0d3",
	"./download_template.svg": "4347",
	"./error-check.svg": "759a",
	"./error-mess.svg": "e08e",
	"./exit-icon.svg": "6a11",
	"./exit.svg": "a2ab",
	"./eye-closed.svg": "f094",
	"./eye.svg": "7364",
	"./facebookIcon.svg": "cd0d",
	"./file.svg": "a147",
	"./filter.svg": "2376",
	"./ico-link.svg": "de66",
	"./info.svg": "76ed",
	"./info_light.svg": "c2c4",
	"./info_questions.svg": "d9ad",
	"./key.svg": "daf4",
	"./letter.svg": "7c5d",
	"./linkedin.svg": "9ed9",
	"./loading_icon.svg": "5172",
	"./login.svg": "ca2f",
	"./logo.svg": "5b1c",
	"./magnifier.svg": "2d43",
	"./map_google_icon.svg": "7f77",
	"./men-icon.svg": "59b8",
	"./ok-status.svg": "c56e",
	"./pdf.svg": "5730",
	"./pending.svg": "e25a",
	"./photo_upload.svg": "7aa6",
	"./plus.svg": "eb38",
	"./pres_0.svg": "9bc3",
	"./print.svg": "671e",
	"./sandwich.svg": "e796",
	"./search.svg": "d103",
	"./select-arrow.svg": "3dbd",
	"./signed.svg": "a575",
	"./slider_left.svg": "70cf",
	"./slider_right.svg": "198d",
	"./smart_subscribe.svg": "2e57",
	"./star.svg": "cc90",
	"./status_approved.svg": "9a9e",
	"./status_calendar_green.svg": "24a1",
	"./status_calendar_yellow.svg": "b062",
	"./status_clock.svg": "663c",
	"./status_declined.svg": "db85",
	"./status_draft.svg": "dc9b",
	"./status_flag_green.svg": "7c29",
	"./status_flag_yellow.svg": "52c3",
	"./status_pencil_ruler.svg": "0494",
	"./status_submitted.svg": "6abb",
	"./success-check.svg": "7580",
	"./tooltip.svg": "401d",
	"./tooltip_empty.svg": "80c0",
	"./tooltip_tail.svg": "5334",
	"./trash.svg": "af22",
	"./twitter.svg": "acf9",
	"./txt_align-center.svg": "da15",
	"./txt_align-justify.svg": "81c4",
	"./txt_align-left.svg": "0d66",
	"./txt_align-right.svg": "b596",
	"./txt_blockquote.svg": "4c1a",
	"./txt_bold.svg": "11a7",
	"./txt_break.svg": "b9bc",
	"./txt_bullet-list.svg": "cf37",
	"./txt_clear-all.svg": "dc10",
	"./txt_h1.svg": "070a",
	"./txt_h2.svg": "51ae",
	"./txt_horizontal-line.svg": "63de",
	"./txt_italic.svg": "d085",
	"./txt_ordered-list.svg": "705b",
	"./txt_paragraph.svg": "38eb",
	"./txt_redo.svg": "d9c2",
	"./txt_standart.svg": "c683",
	"./txt_strike.svg": "c556",
	"./txt_underline.svg": "9903",
	"./txt_undo.svg": "cceb",
	"./unsigned.svg": "963f",
	"./upload_small.svg": "8b47",
	"./upload_small_black.svg": "1696",
	"./vote-green.svg": "f3d0",
	"./vote-grey.svg": "a423",
	"./vote-orange.svg": "ba25",
	"./vote-red.svg": "0322",
	"./youtube.svg": "11ef",
	"./zoom_minus.svg": "89d2",
	"./zoom_plus.svg": "10b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";